import { AxiosResponse } from 'axios';
import { IUserAuth } from '../../types';
import { Service } from 'typedi';
import { axiosAuth } from '../axios';
import { ShowNotification } from '../ShowNotification';

@Service()
export class AuthRequest {
  @ShowNotification()
  authorize(login: string, password: string) {
    return axiosAuth.post('/login', { login, password });
  }

  @ShowNotification()
  logout() {
    return axiosAuth.post('/logout', {
    });
  }

  @ShowNotification()
  setUser(userId: number): Promise<AxiosResponse<IUserAuth>> {
    return axiosAuth.get('/users', { params: { userId } });
  }
}
